module.exports = __webpack_public_path__ + "static/img/expand.f6c875ac.svg";